export default __webpack_public_path__ + "static/media/nilfundme logo final.be26c051.png";